import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, Input, message } from 'antd';
import { setFeedbackMsg } from '../../../api/meeting';
let timer: NodeJS.Timeout;
const { TextArea } = Input;

interface IProps {
}

const Editor: React.FC<IProps> = () => {
  const [value, setFeedValue] = useState<string>('');
  const [buttonText, setbuttonText] = useState('提交');
  const COUNTDWON_NUM = 30;
  const count = useRef<number>(COUNTDWON_NUM);
  const isClick = useRef<boolean>(false);

  // 清除定时
  useEffect(() => {
    return () => {
      clearInterval(timer);
      isClick.current = false;
    };
  }, []);

  const _onClick = () => {
    if (isClick.current) return;
    isClick.current = true;
    timer = setInterval(() => {
      if (count.current > 0) {
        setbuttonText(`${count.current--}s`);
        return;
      }

      resetTimer();
    }, 1000);
  };

  const resetTimer = () => {
    clearInterval(timer);
    setbuttonText('提交');
    isClick.current = false;
    count.current = COUNTDWON_NUM;
  };

  // 反馈意见写入
  const onChange = (e:any) => {
    setFeedValue(e.target.value);
  };

  // 提交反馈意见
  const onSubmit = (e:any) => {
    setFeedValue(e.target.value);
    // 内容为空禁止提交
    if (!value) {
      return;
    }
    _onClick();
    message.loading('提交中');
    setFeedbackMsg(value).subscribe(message.success('提交成功'),
      (error) => {
        const { data } = error.response;

        if (data.code === 4031000) {
          message.error('提交间隔应大于30秒');
        } else {
          message.error('提交失败');
        }
      });
  };

  return (
    <>
      <Form.Item>
        <TextArea showCount maxLength={120} rows={4} onChange={onChange} value={value} placeholder="会议预约使用过程中遇到的问题与建议？"/>
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit"
        onClick={onSubmit}
        type="primary"
        disabled = {isClick.current}
        >
        {buttonText}
        </Button>
      </Form.Item>
    </>
  );
};

export default Editor;
